const { MEASUREMENT_ID, productionAllowed, safeLocation, itemFor, cartSnapshot, cartDeltas, ecommerce } = require('./commerce-measurement')

// Shopify Google & YouTube owns checkout/payment/purchase/refund.
// Never fabricate a purchase from a checkout click or a completed-cart reset.
const init = function ({ router, store }) {
  if (!productionAllowed(window.location, document.cookie)) return
  const debug = new URLSearchParams(window.location.search).get('analytics_test') === '1'
  let configured = false
  let previousMarketing
  let previousPage = ''
  let previousProduct = ''
  let previousCart = cartSnapshot(store.state)
  let cartOpen = false

  const allowed = () => {
    try { return window.SelahatinConsent?.allows('analytics') === true } catch (_) { return false }
  }
  const tag = function () { window.gtag.apply(window, arguments) }
  const send = (name, params) => {
    if (!allowed() || !configured) return
    try { tag('event', name, { ...params, ...(debug ? { debug_mode: true } : {}), send_to: MEASUREMENT_ID }) } catch (_) { /* Measurement must never interrupt shopping. */ }
  }
  const sync = () => {
    if (!allowed()) { previousProduct = ''; previousPage = ''; return }
    const marketing = window.SelahatinConsent.allows('marketing')
    if (!configured) {
      window.dataLayer = window.dataLayer || []
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments) }
      window['ga-disable-' + MEASUREMENT_ID] = false
      tag('js', new Date())
      tag('config', MEASUREMENT_ID, { ...(debug ? { debug_mode: true } : {}), page_location: safeLocation(window.location.href), page_referrer: document.referrer ? safeLocation(document.referrer).split('?')[0] : '', send_page_view: false, cookie_domain: 'selahatin.com', allow_google_signals: marketing, allow_ad_personalization_signals: marketing })
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        const script = document.createElement('script')
        script.async = true
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + MEASUREMENT_ID
        document.head.appendChild(script)
      }
      configured = true
      previousMarketing = marketing
    }
    if (previousMarketing !== marketing) {
      tag('config', MEASUREMENT_ID, { send_page_view: false, allow_google_signals: marketing, allow_ad_personalization_signals: marketing })
      previousMarketing = marketing
    }
    const route = router.currentRoute
    const location = safeLocation(window.location.href)
    const doc = store.state.products.find(product => product.uid === route.params.slug)
    const product = doc && store.state.shopifyProducts.find(product => product.title === doc.data.shopify_product_title)
    tag('set', 'page_location', location)
    tag('set', 'page_title', document.title)
    // A cold product route waits for its content rather than reporting the
    // previous page's title while Prismic/Shopify requests are still resolving.
    const pageReady = route.name !== 'shop__product' || Boolean(product)
    if (pageReady && route.path !== previousPage) {
      const page = { page_location: location, page_title: document.title, page_referrer: previousPage ? window.location.origin + previousPage : document.referrer ? safeLocation(document.referrer).split('?')[0] : '' }
      tag('config', MEASUREMENT_ID, { ...page, send_page_view: false })
      send('page_view', page)
      previousPage = route.path
    }
    if (product) {
      const kebab = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
      const variant = product.variants.find(v => kebab(v.title) === route.query.variant) || product.variants.find(v => v.available) || product.variants[0]
      const item = itemFor(variant, product)
      const key = route.path + '|' + variant?.id
      if (item && key !== previousProduct) {
        send('view_item', { ...ecommerce([item], variant.price?.currencyCode || store.state.shopInfo?.currencyCode || 'EUR'), page_location: location })
        previousProduct = key
      }
    } else previousProduct = ''
    const open = Boolean(store.state.cartVisible)
    if (open && !cartOpen && store.state.cart?.id) {
      const snapshot = cartSnapshot(store.state)
      if (snapshot.items.length) send('view_cart', ecommerce(snapshot.items, snapshot.currency))
      cartOpen = true
    } else if (!open) cartOpen = false
  }
  const safelySync = () => {
    try { sync() } catch (_) { if (debug) console.warn('Selahatin analytics synchronization unavailable') }
  }
  let pendingFrame = false
  const scheduleSync = () => {
    if (pendingFrame) return
    // Vue renders and async component metadata settle before the next paint.
    // Coalesce route and store notifications so a pageview uses that title.
    if (typeof window.requestAnimationFrame !== 'function') return safelySync()
    pendingFrame = true
    window.requestAnimationFrame(() => { pendingFrame = false; safelySync() })
  }
  store.subscribe((mutation, state) => {
    try {
      const current = cartSnapshot(state)
      // Initial hydration/reset must not become an add/remove event. Only confirmed
      // API responses and subscription mutations carry actual cart deltas.
      if (['setCart', 'setCartSubs'].includes(mutation.type)) cartDeltas(previousCart, current).forEach(event => send(event.name, event.params))
      previousCart = current
      scheduleSync()
    } catch (_) { if (debug) console.warn('Selahatin cart measurement unavailable') }
  })
  router.afterEach(scheduleSync)
  window.addEventListener('selahatin:consent-changed', scheduleSync)
  scheduleSync()
}

module.exports = init
